import { EscPosBase64Decoder } from "./EscPosBase64Decoder";
import { QzTrayPayloadDTO } from "../../types/qztray/QzTrayTypes";

export class BackendQzPayloadAdapter {

  private static resolveAlignment(align?: string): string | null {

    if (!align) return null;

    switch (align.toLowerCase()) {
      case "left":
        return EscPosBase64Decoder.decode("G2EA"); // ESC a 0
      case "center":
        return EscPosBase64Decoder.decode("G2EB"); // ESC a 1
      case "right":
        return EscPosBase64Decoder.decode("G2EC"); // ESC a 2
      default:
        return null;
    }
  }

  public static toRawEscPos(payload: QzTrayPayloadDTO): string[] {

    if (!payload?.commands?.length) {
      throw new Error("Payload vacío: no hay comandos imprimibles.");
    }

    return payload.commands.flatMap((cmd: any) => {

      if (!cmd?.value) return "";

      switch (cmd.type) {

        /** ------------------------------ */
        /**  🖼️ Imagen dinámica            */
        /** ------------------------------ */
        case "IMAGE": {

          const imageBytes = EscPosBase64Decoder.decode(cmd.value);

          const alignment = this.resolveAlignment(cmd.align);

          // Retorno dinámico
          return alignment
            ? [alignment, imageBytes]
            : [imageBytes];
        }

        /** ------------------------------ */
        /**  ✏️ Texto normal                */
        /** ------------------------------ */
        case "TEXT":
        case "QR":
        case "RAW":
          return EscPosBase64Decoder.decode(cmd.value);

        default:
          console.warn(`⚠️ Tipo desconocido ${cmd.type}`);
          return "";
      }
    });
  }
}
